function initStickySideNav() {
  const resizeWidth = $(window).width();
  const mobileBreakpoint = 1025;

  if (resizeWidth < mobileBreakpoint) {
    $('.sidebar-fixed').trigger('sticky_kit:detach');
  } else {
    makeSticky();
  }
}

function makeSticky() {
  $('.sidebar-fixed').stick_in_parent({
    parent: '.article-wrapper',
    spacer: false,
    recalc_every: 1,
    sticky_class: 'is-stuck',
  });
}

export default { initStickySideNav };



// WEBPACK FOOTER //
// ./src/js/custom/sticky-side-nav.js